import * as React from "react";
import { useTheme } from "../context/ThemeContext";

const certificates = [
  { name: "GDG", img: "/assets/gdg.png", link: "https://www.linkedin.com/posts/jessile-joyce-bonzo_before-the-month-ends-i-want-to-extend-my-activity-7224417683008540673-cmAl?utm_source=share&utm_medium=member_desktop&rcm=ACoAACfaFboBeTCNqglqMbEOYzHkH5hWuZfM9Ng" },
  { name: "Udemy", img: "/assets/udemy.png", link: "https://www.linkedin.com/posts/jessile-joyce-bonzo_webdevelopment-mern-techjourney-activity-7263523421014110208-BJBm?utm_source=share&utm_medium=member_desktop&rcm=ACoAACfaFboBeTCNqglqMbEOYzHkH5hWuZfM9Ng" },
  { name: "Cisco", img: "/assets/cisco.png", link: "https://www.linkedin.com/posts/jessile-joyce-bonzo_im-happy-to-share-that-ive-obtained-a-new-activity-7211033417742790656-rNOV?utm_source=share&utm_medium=member_desktop&rcm=ACoAACfaFboBeTCNqglqMbEOYzHkH5hWuZfM9Ng" },
  { name: "freeCodeCamp", img: "/assets/fcc.png", link: "https://www.freecodecamp.org/certification/jessile_bonzo/machine-learning-with-python-v7" },
];

const Cert: React.FC = () => {
  const { isDarkMode } = useTheme();

  return (
    <div 
      className={`text-center py-8 ${
        isDarkMode ? 'bg-primary' : 'bg-gray-200'
      } transition-colors duration-300`}
      id="certificates"
    >
      <h2 className="text-3xl font-bold" style={{ color: "#83329A" }}>
        Certificates
      </h2>
      <p className={`mt-2 mb-8 text-lg ${
        isDarkMode ? 'text-tertiary' : 'text-gray-600'
      } transition-colors duration-300`}>
        Here are the certificates I earned
      </p>
      <div className="px-6 md:px-16 lg:px-24 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {certificates.map((cert, index) => (
            <a
              key={index}
              href={cert.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`px-6 py-3 rounded-lg flex flex-col items-center justify-center shadow-lg transition-all transform hover:scale-105 ${
                isDarkMode 
                  ? 'bg-[#A988D8] hover:bg-gradient-to-r hover:from-[#83329A] hover:to-[#242f47]' 
                  : 'bg-[#A988D8] hover:bg-gradient-to-r hover:from-[#83329A] hover:to-[#707374]'
              } font-semibold`}
            >
              <img 
                src={cert.img} 
                alt={cert.name} 
                className="w-13 h-12 mb-1 transition-colors duration-300 hover:filter-none" 
              />
              <span className={`${
                isDarkMode ? 'text-white' : 'text-gray-800'
              } font-medium transition-colors duration-300 hover:text-gray-300`}>
                {cert.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Cert;